(async () => {    
    const baseComponent = await import(window.theme.modules.baseComponent);
    
    function isPositiveInteger(value)   {
        return Number.isInteger(value) && value > 0;
    }

    customElements.define('product-qty-input', class extends baseComponent.default {
        elements = {
            buttonMinus: '[data-button-minus]',
            buttonPlus: '[data-button-plus]',
            input: '[data-input]',
        }
    
        currentValue = 1;
    
        render() {
            this.$buttonMinus.addEventListener('click', this._changeBy(-1));
            this.$buttonPlus.addEventListener('click', this._changeBy(1));
            this.$input.addEventListener('change', this._handleChange.bind(this));
            this._toggleButtons();
        }
    
        _changeBy(value) {
            return () => {
                this.currentValue += value;
                this._applyCurrentValue();
            }
        }
    
        _handleChange({ target }) {
            const value = target.valueAsNumber;
            if (this.qtyLimit && value > this.qtyLimit) {
                this.currentValue = this.qtyLimit;
            } else if (!isPositiveInteger(value)) {
                this.currentValue = 1;
            } else {
                this.currentValue = value;
            }
            this._applyCurrentValue();
        }
    
        _applyCurrentValue() {
            this.$input.value = this.currentValue;
            this._toggleButtons();
        }
        
        _toggleButtons() {       
            this.$buttonMinus.toggleAttribute('disabled', this.currentValue === 1);
            this.$buttonPlus.toggleAttribute('disabled', this.currentValue === this.qtyLimit);
        }
    
        get qtyLimit() {
            return +this.$input.getAttribute('max');
        }
    })

})();